/* src/app/notification-settings/location-settings-grid/location-settings/location-settings.component.scss */
.error {
  outline: 2px solid #C91A13;
  outline-offset: -1px;
}
::ng-deep .error on-off-toggle {
  position: relative;
}
::ng-deep .error on-off-toggle:after {
  font-family: upsicons, fantasy !important;
  content: "\e638" !important;
  color: #C91A13;
  position: absolute;
  top: calc(50% - 0.7em);
  right: -25px;
}
.location-header {
  border-top: none !important;
  border-left: 1px solid #757575 !important;
  padding: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}
th {
  border: 1px solid #757575;
  border-left: none;
}
td {
  border-right: 1px solid #757575;
  border-bottom: 1px solid #757575;
  vertical-align: middle;
  padding: 0 28px;
}
.comment-notifications,
.request-edited-notifications {
  display: flex;
  justify-content: center;
  align-items: center;
}
status-change-notifications {
  display: flex;
}
/*# sourceMappingURL=location-settings.component.css.map */
